var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCursor = function SvgArrowCursor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "arrow-cursor_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M59.01 15.58 4 4l11.58 55.01 13.806-13.806L44.182 60 60 44.182 45.204 29.386z"
  })));
};
export { SvgArrowCursor as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBkPSJNNTkuMDA5MiAxNS41ODA5TDQgNEwxNS41ODA5IDU5LjAwOTRMMjkuMzg2MyA0NS4yMDM5TDQ0LjE4MjUgNjBMNjAuMDAwMSA0NC4xODI0TDQ1LjIwMzkgMjkuMzg2M0w1OS4wMDkyIDE1LjU4MDlaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";